import { defineStore } from "pinia";
import { canPerformAction, type PermissionsMap } from "@parkingmgt/iam-sdk-ts";
import { getAvailableReports } from "@/helpers/reporting";
import { useAppUserStore } from "@/stores/app-user";
import {
  USE_REVENUE_DASHBOARD,
  USE_FRONTDESK_DASHBOARD,
  USE_OCCUPANCY_DASHBOARD,
  USE_VALIDATION_DASHBOARD,
  USE_VALETINSIGHTS_DASHBOARD,
  USE_DAILY_LOCATION_SUMMARY_DASHBOARD,
} from "@/helpers/constants";

export const useAppSidebarMenuStore = defineStore({
  id: "appSidebarMenu",
  state: () => {
    const appUserStore = useAppUserStore();

    const userPermissions =
      appUserStore.permissions as unknown as PermissionsMap;

    return [
      // NOTE: Keeping for future reference.
      // {
      //   text: "Menu",
      //   is_header: true,
      // },
      {
        url: "/event",
        icon: "fa-solid fa-ticket",
        text: "Event",
        // Event is venue-scoped and NOT granted by partnerPortal:* — see
        // hasEventAccess in app-user.ts for the rationale.
        canAccess: () => appUserStore.hasEventAccess,
      },
      {
        url: "/front-desk",
        icon: "fa-solid fa-building-circle-check",
        text: "Front Desk",
        canAccess: () =>
          canPerformAction(USE_FRONTDESK_DASHBOARD, userPermissions),
      },
      {
        url: "/daily-location-summary",
        icon: "fa-solid fa-table-list",
        text: "Location Summary",
        canAccess: () =>
          canPerformAction(
            USE_DAILY_LOCATION_SUMMARY_DASHBOARD,
            userPermissions,
          ),
      },
      {
        url: "/occupancy",
        icon: "fa-solid fa-car",
        text: "Occupancy",
        canAccess: () =>
          canPerformAction(USE_OCCUPANCY_DASHBOARD, userPermissions),
      },
      {
        url: "/reporting",
        icon: "fa fa-database",
        text: "Reporting",
        canAccess: (): boolean => getAvailableReports()?.length > 0,
      },
      {
        url: "/",
        icon: "fa-solid fa-chart-line",
        text: "Revenue",
        canAccess: () =>
          canPerformAction(USE_REVENUE_DASHBOARD, userPermissions),
      },
      {
        url: "/valet-insights",
        icon: "fa-solid fa-car-rear",
        text: "Valet Insights",
        canAccess: () =>
          canPerformAction(USE_VALETINSIGHTS_DASHBOARD, userPermissions),
      },
      {
        url: "/validation",
        icon: "fa-solid fa-tag",
        text: "Validation",
        canAccess: () =>
          canPerformAction(USE_VALIDATION_DASHBOARD, userPermissions),
      },
      // NOTE: Keeping for future reference.
      // {
      //   is_divider: true,
      // },
    ];
  },
});
